import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Status from './Status';
import Main from './Component/Main';
import { CircleLoader } from 'react-spinners';
import { ErrorBoundary } from './ErrorBoundary';
import NotFound from './helper/errorPages/NotFoundPage';
import ServerErrorPage from './ErrorPage';
import ScholarshipClosed from './helper/ScholarshipClosed';
import VerticalStepperForMultipleYearRequest from './Multipleyearrequest/Stepper';
import Development from './development/Main';
import DevelopmentApply from './development/components/Stepper/Main';
import Finishui from './development/components/Finishui';
import Container from '@mui/material/Container';
import Charity from './charity/Main';
import CharityApply from './charity/components/Stepper/Main';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/scholarship" replace />} />
      <Route
        path="/scholarship"
        element={
          <React.Suspense fallback={<CircleLoader />}>
            <ErrorBoundary fallback={<ServerErrorPage />}>
              <Container>
                <Main />{' '}
              </Container>
            </ErrorBoundary>
          </React.Suspense>
        }
      />
      <Route
        path="/status"
        element={
          <React.Suspense fallback={<CircleLoader />}>
            <ErrorBoundary fallback={<ServerErrorPage />}>
              <Status />
            </ErrorBoundary>
          </React.Suspense>
        }
      />
      <Route
        path="/development"
        element={
          <React.Suspense fallback={<CircleLoader />}>
            <ErrorBoundary fallback={<ServerErrorPage />}>
              <Development />
            </ErrorBoundary>
          </React.Suspense>
        }
      />
      <Route
        path="/charity"
        element={
          <React.Suspense fallback={<CircleLoader />}>
            <ErrorBoundary fallback={<ServerErrorPage />}>
              <Charity />
            </ErrorBoundary>
          </React.Suspense>
        }
      />
      <Route
        path="/charity/apply"
        element={
          <React.Suspense fallback={<CircleLoader />}>
            <ErrorBoundary fallback={<ServerErrorPage />}>
              <CharityApply />
            </ErrorBoundary>
          </React.Suspense>
        }
      />

      <Route
        path="/development/apply"
        element={
          <React.Suspense fallback={<CircleLoader />}>
            <ErrorBoundary fallback={<ServerErrorPage />}>
              <DevelopmentApply />
            </ErrorBoundary>
          </React.Suspense>
        }
      />
      <Route
        path="/form"
        element={
          <React.Suspense fallback={<CircleLoader />}>
            <ErrorBoundary fallback={<ServerErrorPage />}>
              <VerticalStepperForMultipleYearRequest />
            </ErrorBoundary>
          </React.Suspense>
        }
      />
      <Route
        path="/closed"
        element={
          <React.Suspense fallback={<CircleLoader />}>
            <ErrorBoundary fallback={<ServerErrorPage />}>
              <ScholarshipClosed />
            </ErrorBoundary>
          </React.Suspense>
        }
      />
      <Route
        path="/successfully-submitted"
        element={
          <React.Suspense fallback={<CircleLoader />}>
            <ErrorBoundary fallback={<ServerErrorPage />}>
              <Finishui />
            </ErrorBoundary>
          </React.Suspense>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
